import { Injectable } from '@angular/core';

import { LzUserServiceV2 } from "../../lz-user/services/lz-user.serivce.v2";

declare var $: any;

@Injectable()
export class LzLogService {

  constructor(private user: LzUserServiceV2) {}

  public logForHadoop = (path: string, data ? : any) => {
    this.user.getUserInfo(function (info) {
      $.ajax({
        url: '/userevent/' + (info.email || 'undefined') + '/' + path,
        type: "GET",
        data: data || {}
      });
    });
  }


}
